<template>
  <div class="units-container app-container">
    <h2 class="page-title"><i class="el-icon-box"></i> 已购单位</h2>
    
    <el-row :gutter="20" v-loading="listLoading">
      <el-col 
        v-for="item in list" 
        :key="item.Id"
        :xs="24" 
        :sm="12" 
        :md="8" 
        :lg="6"
        class="unit-card"
      >
        <el-card shadow="hover">
          <div slot="header" class="card-header">
            <h3 class="unit-name">{{ item.UnitName }}</h3>
            <el-tag 
              :type="item.IsActive ? 'success' : 'danger'" 
              effect="plain"
              size="mini"
            >
              {{ item.IsActive ? '已启用' : '已禁用' }}
            </el-tag>
          </div>
          
          <div class="card-content">
            <div class="usage-info">
              <el-tag 
                :type="getUsageType(item.RemainingUsage)"
                effect="dark"
                class="usage-tag"
              >
                <span class="count-text">剩余次数</span>
                <span class="count-number">
                  {{ item.RemainingUsage === -1 ? '∞' : item.RemainingUsage }}
                </span>
              </el-tag>
            </div>
            
            <div class="meta-info">
              <div class="danmu-command">
                <el-input 
                  v-model="item.DanmuCommand" 
                  size="small" 
                  placeholder="弹幕指令"
                  @change="handleUpdateDanmuCommand(item)"
                  clearable
                >
                  <template slot="prepend">指令</template>
                </el-input>
              </div>
              
              <el-button 
                :type="item.IsActive ? 'danger' : 'success'"
                size="small"
                :loading="item.statusLoading"
                @click="handleToggleStatus(item)"
                class="status-btn"
              >
                {{ item.IsActive ? '禁用' : '启用' }}
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getPurchasedUnits, toggleUnitStatus, updateUnitDanmuCommand } from '@/api/api'

export default {
  data() {
    return {
      list: [],
      listLoading: false
    }
  },
  methods: {
    // 获取已购单位
    handleQuery() {
      this.listLoading = true
      getPurchasedUnits().then(res => {
        if (!res.data.success) {
          if (res.data.msg === '用户未绑定游戏角色') {
            this.$message.error('请先绑定游戏角色')
            this.$router.push('/usercenter/profile')
            return
          }
          this.$message.error(res.data.msg || '获取数据失败')
          return
        }
        this.list = res.data.response.map(item => ({
          ...item,
          statusLoading: false,
          IsActive: item.IsActive
        }))
      }).finally(() => {
        this.listLoading = false
      })
    },

    // 切换状态
    async handleToggleStatus(item) {
      item.statusLoading = true
      try {
        const res = await toggleUnitStatus(item.UnitId)
        if (res.data.success) {
          item.IsActive = res.data.response
          this.$message.success(res.data.msg)
        }
      } catch (error) {
        this.$message.error('状态切换失败')
      } finally {
        item.statusLoading = false
      }
    },

    // 更新弹幕指令
    async handleUpdateDanmuCommand(item) {
      try {
        const params = {
          UnitId: item.UnitId,
          NewDanmuCommand: item.DanmuCommand
        }
        const res = await updateUnitDanmuCommand(params)
        if (res.data.success) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg || '更新失败')
        }
      } catch (error) {
        this.$message.error('弹幕指令更新失败')
      }
    },

    // 根据剩余次数显示不同颜色
    getUsageType(count) {
      if (count === -1) return 'primary' // 无限次数显示为蓝色
      if (count >= 40) return 'success'
      if (count >= 10) return 'warning'
      return 'danger'
    },

    // 格式化时间
    formatTime(timeStr) {
      return timeStr ? timeStr.substr(0, 16).replace(' ', '<br>') : '-'
    }
  },
  mounted() {
    this.handleQuery()
  }
}
</script>

<style scoped>
.page-title {
  color: #666;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.units-container {
  padding: 20px;
}

.unit-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.unit-name {
  margin: 0;
  font-size: 16px;
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 调整卡片内容布局 */
.card-content {
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.usage-info {
  text-align: center;
  margin-bottom: 15px;
}

.usage-tag {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 15px;
  min-width: 100px;
  border-radius: 25px;
  line-height: 1;
  box-sizing: border-box;
}

.count-text {
  font-size: 12px;
  margin-bottom: 3px;
}

.count-number {
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  margin-top: 2px;
}

.meta-info {
  margin-top: 15px;
  text-align: center;
}

.danmu-command {
  margin-bottom: 10px;
}

.status-btn {
  min-width: 60px;
}
</style>